import { Box } from "@mui/material"
import type { FC } from "react"

import { useSourceChangeList } from "../hooks/useSourceChangeList"

import { SourceChangeTable } from "./SourceChangeTable"

import { NotificationType } from "@/schemas/notification"
import { useNotificationsStore } from "@/stores/useNotificationsStore"

export const SourceChangeTabPanel: FC = () => {
  const notify = useNotificationsStore((state) => state.enqueueNotification)

  const { sourceChanges, isFetching, error, tableContainerRef, handleScroll } = useSourceChangeList()

  const handleApprove = () => {
    // TODO(AK-7144): Call the approve mutation once the backend exposes it.
    notify({ type: NotificationType.Warning, message: "Approve feature coming soon" })
  }

  const handleReject = () => {
    // TODO(AK-7144): Call the reject mutation once the backend exposes it.
    notify({ type: NotificationType.Warning, message: "Reject feature coming soon" })
  }

  return (
    <Box className='flex min-h-0 flex-1 overflow-y-auto' data-testid='dashboard.source-change-tab-panel'>
      <SourceChangeTable
        data={sourceChanges}
        loading={isFetching}
        error={error}
        containerRef={tableContainerRef}
        onScroll={handleScroll}
        onApprove={handleApprove}
        onReject={handleReject}
      />
    </Box>
  )
}
